import { ZervantLocale } from '@features/invoices/enums/zervantLocale'
import { useCurrentUser } from '@modules-deprecated/app/user'

import { SalesReportLocaleIdentifier } from '../types/salesReportLocaleIdentifier'

const unsupportedLocales = ['en_US', 'da_DK']

const DEFAULT_LOCALE = ZervantLocale.EN_GB

export const useExportSupportedLocale = (): SalesReportLocaleIdentifier => {
  const { user } = useCurrentUser()

  if (!user?.locale || unsupportedLocales.includes(user.locale)) {
    return DEFAULT_LOCALE
  }

  return user.locale
}
